import { css } from 'styled-components';

export const BlackBoxBase = css`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  background: rgba(0, 0, 0, 0.48);
  box-shadow: ${({ theme }) => theme.shadow.CONTAINER};
  color: ${({ theme }) => theme.colors.WHITE};
  display: inline-flex;
  align-items: center;
`;
